import { db } from '.';
import { nextString } from '../utils/string';
import config from '../firebase.config';

const deepLinkCreateUrl = `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${
  config.apiKey
}`;

export function startsWithQuery(collectionRef, field, startsWith) {
  return collectionRef
    .where(field, '>=', startsWith)
    .where(field, '<', nextString(startsWith));
}

// Ref is CollectionReference/QueryReference
export async function performMoveInDB(ref, from, to) {
  let start = from,
    end = to;
  if (start > end) {
    start = to;
    end = from;
  }

  const query = ref
    .where('serialNumber', '>=', start)
    .where('serialNumber', '<=', end);
  const querySnapshot = await query.get();
  const batch = db.batch();
  querySnapshot.docs.forEach(doc => {
    const oldSN = doc.data().serialNumber;
    let newSN;
    if (from === oldSN) {
      newSN = to;
    } else if (from === start) {
      newSN = oldSN - 1;
    } else {
      newSN = oldSN + 1;
    }
    batch.update(doc.ref, { serialNumber: newSN });
  });

  await batch.commit();
}

export async function doesFileExists(storageReference) {
  try {
    await storageReference.getDownloadURL();
    return true;
  } catch {
    return false;
  }
}

export async function generateDeepLink(link, name, description, image) {
  const params = {
    dynamicLinkInfo: {
      domainUriPrefix: process.env.VUE_APP_DEEP_LINK_DOMAIN,
      link: `${process.env.VUE_APP_WEB_APP_DOMAIN}${link}`,
      androidInfo: {
        androidPackageName: process.env.VUE_APP_ANDROID_PACKAGE_NAME
      },
      iosInfo: {
        iosBundleId: process.env.VUE_APP_DEEP_IOS_BUNDLE_ID,
        iosAppStoreId: process.env.VUE_APP_DEEP_IOS_APP_STORE_ID
      },
      navigationInfo: {
        enableForcedRedirect: false
      },
      socialMetaTagInfo: {
        socialTitle: name,
        socialDescription: description,
        ...(image ? { socialImageLink: image } : {})
      }
    },
    suffix: {
      option: 'SHORT'
    }
  };

  const response = await fetch(deepLinkCreateUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(params)
  });

  return response.json();
}
